module.exports = __webpack_public_path__ + "img/turkcell-t50.d10f8175.png";